export class ActiveInfo {
  constructor() {
    this.active = true
  }

  buildParam() {
    return `active=${this.active}`
  }
}
